import i18n from "@/i18n";
import consts from "@/consts.js";
import datetimeUtils from "@/plugins/datetimeUtils.js";

export default {
    distribution: {
      distribution: {
        id: 1,
        order_id: 1,
        order_code: "A" + datetimeUtils.formatDateForCode() + "000001",
        distributions_code: "B" + datetimeUtils.formatDateForCode() + "000001-1",
        alliance_business_id: null,
        shop_id: 1,
        shop_user_id: 0,
        distribution_user_id: null,
        delete_flg: false,
        distribution_time: null,
        created_id: 1,
        created: datetimeUtils.formatTime(new Date()),
        modified_id: null,
        modified: datetimeUtils.formatTime(new Date()),
        distribution_center_id: 1,
        stock_area_id: null,
        is_printed: 0,
        logistics_code: null,
        logistics_name: null,
        logistics_link_man: null,
        logistics_price: 0,
        status: 1,
        print_count: 1,
        memo: "",
        shop_distribution_code: null,
        supplier_distribution_code: null,
        shop_account_id: null,
        supplier_account_id: null,
        total_distribution_num: "12.000",
        total_distribution_price: "0.720000",
        stock_id: 1,
        stock_tel: "",
        stock_name: "XX" + i18n.t("Stock.ObjectName"),
        shop: {
          id: 115,
          alliance_business_id: 0,
          price_level_id: null,
          shop_code: "ShopCode001",
          shop_name: "XX" + consts.shopName(),
          material_template_id: 0,
          product_template_id: 0,
          city_1: "010000000000",
          city_2: null,
          city_3: null,
          address: i18n.t("Shop.Fields.shop_address", [consts.shopName()]),
          tel: null,
          fax: null,
          email: null,
          status: 1,
          comment: "",
          activation_code: null,
          pin_code: null,
          equipment_code: null,
          reg_code: null,
          reg_password: null,
          soft_version: null,
          device_cnt: 0,
          reg_flg: 0,
          erp_account: null,
          erp_account_code: null,
          delete_flg: false,
          created_id: null,
          created: datetimeUtils.formatTime(new Date()),
          modified_id: null,
          modified: datetimeUtils.formatTime(new Date()),
          erp_bank: null,
          lng: 113.273,
          lat: 23.098,
          invoice_type: 0,
          invoice_title: null,
          invoice_code: null,
          balance: 474.92,
          sub_account_balance_json: null,
          collect: null,
          order_cycles_code: null,
          shop_pay_setting: null,
          shop_bail: 10000,
          hide_material_price_flg: 0,
          hide_order_price_flg: 0,
          company_name: null,
          national_tax_code: null,
          province_id: null,
          city_id: null,
          area_id: null,
          shop_user: {
            id: 1,
            shop_id: 1,
            login_user_id: "13311113333",
            type: 2,
            name: "姓名",
            identification_num: "",
            tel: "13311113333",
            mobile: null,
            email: null,
            role: 1,
            sex: null,
            delete_flg: false,
            created_id: null,
            created: datetimeUtils.formatTime(new Date()),
            modified_id: null,
            modified: datetimeUtils.formatTime(new Date()),
          },
          template_name: "默认模板",
        },
        distribution_user: null,
        distribution_details: [
          {
            id: 1,
            distributions_id: 4299,
            material_id: 2486,
            material_code: "511001",
            material_name: "511001",
            category_code: "00000000001",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000001",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.1,
            standard_detail_id: 2473,
            out_detail_id: 19138,
            detail_stock_id: "40",
            stock_detail_id: 532,
            stock_batch_code: "5110010120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511001",
            barcode: "511001",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511001",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511001",
            stock_unit_num: "1件",
            sum: 0.1,
            cat_num_sum: 1,
            cat_sum: 0.1,
          },
          {
            id: 2,
            distributions_id: 4299,
            material_id: 2487,
            material_code: "511002",
            material_name: "511002",
            category_code: "00000000001",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000001",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.02,
            standard_detail_id: 2474,
            out_detail_id: 19139,
            detail_stock_id: "40",
            stock_detail_id: 533,
            stock_batch_code: "5110020120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511002",
            barcode: "511002",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511002",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511002",
            stock_unit_num: "1件",
            sum: 0.02,
            cat_num_sum: 2,
            cat_sum: 0.12000000000000001,
          },
          {
            id: 3,
            distributions_id: 4299,
            material_id: 2486,
            material_code: "511003",
            material_name: "511003",
            category_code: "00000000002",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000002",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.1,
            standard_detail_id: 2473,
            out_detail_id: 19138,
            detail_stock_id: "40",
            stock_detail_id: 532,
            stock_batch_code: "5110010120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511003",
            barcode: "511003",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511003",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511003",
            stock_unit_num: "1件",
            sum: 0.1,
            cat_num_sum: 1,
            cat_sum: 0.1,
          },
          {
            id: 4,
            distributions_id: 4299,
            material_id: 2487,
            material_code: "511004",
            material_name: "511004",
            category_code: "00000000004",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000004",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.02,
            standard_detail_id: 2474,
            out_detail_id: 19139,
            detail_stock_id: "40",
            stock_detail_id: 533,
            stock_batch_code: "5110020120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511004",
            barcode: "511004",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511004",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511004",
            stock_unit_num: "1件",
            sum: 0.02,
            cat_num_sum: 2,
            cat_sum: 0.12000000000000001,
          },
          {
            id: 5,
            distributions_id: 4299,
            material_id: 2486,
            material_code: "511005",
            material_name: "511005",
            category_code: "00000000004",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000004",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.1,
            standard_detail_id: 2473,
            out_detail_id: 19138,
            detail_stock_id: "40",
            stock_detail_id: 532,
            stock_batch_code: "5110010120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511005",
            barcode: "511005",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511005",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511005",
            stock_unit_num: "1件",
            sum: 0.1,
            cat_num_sum: 1,
            cat_sum: 0.1,
          },
          {
            id: 6,
            distributions_id: 4299,
            material_id: 2487,
            material_code: "511006",
            material_name: "511006",
            category_code: "00000000004",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000004",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.02,
            standard_detail_id: 2474,
            out_detail_id: 19139,
            detail_stock_id: "40",
            stock_detail_id: 533,
            stock_batch_code: "5110020120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511006",
            barcode: "511006",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511006",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511006",
            stock_unit_num: "1件",
            sum: 0.02,
            cat_num_sum: 2,
            cat_sum: 0.12000000000000001,
          },
          {
            id: 7,
            distributions_id: 4299,
            material_id: 2486,
            material_code: "511007",
            material_name: "511007",
            category_code: "00000000004",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000004",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.1,
            standard_detail_id: 2473,
            out_detail_id: 19138,
            detail_stock_id: "40",
            stock_detail_id: 532,
            stock_batch_code: "5110010120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511007",
            barcode: "511007",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511007",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511007",
            stock_unit_num: "1件",
            sum: 0.1,
            cat_num_sum: 1,
            cat_sum: 0.1,
          },
          {
            id: 8,
            distributions_id: 4299,
            material_id: 2487,
            material_code: "511008",
            material_name: "511008",
            category_code: "00000000001",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000001",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.02,
            standard_detail_id: 2474,
            out_detail_id: 19139,
            detail_stock_id: "40",
            stock_detail_id: 533,
            stock_batch_code: "5110020120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511008",
            barcode: "511008",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511008",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511008",
            stock_unit_num: "1件",
            sum: 0.02,
            cat_num_sum: 2,
            cat_sum: 0.12000000000000001,
          },
          {
            id: 9,
            distributions_id: 4299,
            material_id: 2486,
            material_code: "511009",
            material_name: "511009",
            category_code: "00000000002",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000002",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.1,
            standard_detail_id: 2473,
            out_detail_id: 19138,
            detail_stock_id: "40",
            stock_detail_id: 532,
            stock_batch_code: "5110010120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511009",
            barcode: "511009",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511009",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511009",
            stock_unit_num: "1件",
            sum: 0.1,
            cat_num_sum: 1,
            cat_sum: 0.1,
          },
          {
            id: 10,
            distributions_id: 4299,
            material_id: 2487,
            material_code: "5110010",
            material_name: "5110010",
            category_code: "00000000006",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000006",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.02,
            standard_detail_id: 2474,
            out_detail_id: 19139,
            detail_stock_id: "40",
            stock_detail_id: 533,
            stock_batch_code: "5110020120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "5110010",
            barcode: "5110010",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "5110010",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "5110010",
            stock_unit_num: "1件",
            sum: 0.02,
            cat_num_sum: 2,
            cat_sum: 0.12000000000000001,
          },
          {
            id: 11,
            distributions_id: 4299,
            material_id: 2486,
            material_code: "511011",
            material_name: "511011",
            category_code: "00000000007",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000007",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.1,
            standard_detail_id: 2473,
            out_detail_id: 19138,
            detail_stock_id: "40",
            stock_detail_id: 532,
            stock_batch_code: "5110010120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511011",
            barcode: "511011",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511011",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511011",
            stock_unit_num: "1件",
            sum: 0.1,
            cat_num_sum: 1,
            cat_sum: 0.1,
          },
          {
            id: 12,
            distributions_id: 4299,
            material_id: 2487,
            material_code: "511012",
            material_name: "511012",
            category_code: "00000000007",
            category_rank: 1,
            category_sort: 8,
            category_number: "09",
            category_name: "00000000007",
            distribution_num: 1,
            default_distribution_num: 1,
            memo: "",
            unit: "件",
            price: 0.02,
            standard_detail_id: 2474,
            out_detail_id: 19139,
            detail_stock_id: "40",
            stock_detail_id: 533,
            stock_batch_code: "5110020120210511001",
            production_date: "2021/05/11 00:00:00",
            expired_date: "2021/08/31 00:00:00",
            standard_name: "",
            standard_barcode: "511012",
            barcode: "511012",
            distribution_unit_rate: "1.000",
            default_unit: "件",
            default_unit_rate: "1.000",
            default_unit_barcode: "511012",
            stock_unit: "件",
            stock_unit_rate: "1.000",
            stock_unit_barcode: "511012",
            stock_unit_num: "1件",
            sum: 0.02,
            cat_num_sum: 12,
            cat_sum: 0.72000000000000001,
          },
        ],
        contact_method: "",
        creater_name: "system",
        modifier_name: "system",
        shop_user_name: "姓名",
        distribution_user_name: "",
        actions: {distribute: true, logistic: false},
      },
      order: {
        "id": 336,
        "order_code": "A20230823000010",
        "ext_code": null,
        "alliance_business_id": null,
        "relation_order_id": null,
        "shop_id": 12,
        "shop_user_id": 12,
        "admin_user": 1,
        "grant_user_id": 1,
        "invoice_url": null,
        "invoice_type": 0,
        "invoice_rate": 0,
        "status": 5,
        "type": 1,
        "return_type": 2,
        "bill_pay_flg": null,
        "bill_status": 1,
        "price_fix": 36,
        "price_cut": 0,
        "order_price": 46,
        "add_flg": 0,
        "cps_json": null,
        "disable_return": 0,
        "disable_cps": false,
        "shop_account_id": null,
        "shop_purchase_code": null,
        "shop_stock_order_code": null,
        "memo": null,
        "delete_flg": false,
        "created_id": 1,
        "created": "2023/08/23 15:39:01",
        "modified_id": 1,
        "modified": "2023/08/23 15:39:42",
        "account_memo": null,
        "expect_date": "2023/08/24 00:00:00",
        "actual_date": "2023/08/23 15:38:51",
        "cancel_flg": 0,
        "cancel_memo": null,
        "print_count": 0,
        "error_flg": 0,
        "expect_return_price": null,
        "remark": null,
        "check_price": null,
        "order_img": "",
        "origin_flg": "001",
        "express_price": 10,
        "edit_express_flg": 0,
        "coupon_detail_id": null,
        "coupon_json": null,
        "details_count": "1",
        "details_num": "3.000",
        "weight_total": "0.0000000000000",
        "bill_price": "60.000",
        "order_details": [
          {
            "id": 711,
            "order_id": 336,
            "category_name": "食材",
            "category_code": "00AE57A6-667A-096D-E4B4-468EA073438B",
            "material_id": 5586,
            "material_code": "010010006",
            "material_name": "草头",
            "material_alias": null,
            "guid": "FBF13A5C-B36A-A900-F7A0-1F046FB271D1",
            "apply_num": 3,
            "confirm_num": 3,
            "add_num": 0,
            "add_num_comfirm": 0,
            "fix_num": 3,
            "org_price": 12,
            "price": 12,
            "total": 36,
            "subtotal": 0,
            "price_flg": 0,
            "confirm_price": 12,
            "auto_flg": 0,
            "production_date": null,
            "expired_date": null,
            "memo": null,
            "delete_flg": false,
            "created_id": null,
            "created": "2023/08/23 15:39:01",
            "modified_id": null,
            "modified": "2023/08/23 15:39:12",
            "unit": "斤",
            "standard_detail_id": 5587,
            "standard_name": "",
            "error_flg": 0,
            "sub_account_price_json": null,
            "order_combine_material_id": null,
            "img": "",
            "campaign_price": null,
            "coupon_price": null,
            "standard_detail": {
              "id": 5587,
              "standard_id": 5586,
              "unit": "斤",
              "rate": 1,
              "weight": null,
              "barcode": "",
              "comment": "",
              "default_flg": 1,
              "status": 0,
              "delete_flg": 0,
              "unit_code": null,
              "net": null,
              "net_unit": "",
              "weight_flg": 0,
              "gross_weight": null,
              "gross_weight_unit": "",
              "count_unit": "",
              "count_unit_rate": 1,
              "gross_weight_config": null,
              "count_unit_flg": 1
            },
            "material": {
              "id": 5586,
              "material_code": "010010006",
              "material_name": "草头",
              "category_code": "8FD839A5-E9D3-3648-89E8-54CF7A5E679F",
              "guid": "77577259-356E-0D6D-F513-CBAE9834099F",
              "cost_method": 1,
              "pinyin": "CT",
              "material_sname": "",
              "bar_code": "",
              "supply_shop": null,
              "default_supplier_id": null,
              "unit_order": "斤",
              "in_price": "0.00",
              "supply_price": "12.00",
              "supply_standard_detail_id": 5587,
              "multiple": null,
              "stock_max": null,
              "stock_min": null,
              "bestbefore": "",
              "nearday": null,
              "origin": "",
              "brand": null,
              "storage_conditions": null,
              "stock_batch_rule_type": 1,
              "comment": null,
              "video": null,
              "min": "0.00",
              "sort": null,
              "hide_flg": 0,
              "public_flg": 1,
              "production_attribute": 0,
              "combine_formula_json": [],
              "split_formula_json": [],
              "delete_flg": false,
              "created_id": 1,
              "created": "2022/06/30 17:38:21",
              "modified_id": null,
              "modified": "2023/03/31 16:58:19",
              "auto_code_number": 0,
              "transport_type": null,
              "storage_type": 30,
              "ext_code": null,
              "ext_img_url": null,
              "delivery_way": null,
              "freight_type": null,
              "material_group": "",
              "material_group_flg": 0,
              "description": "",
              "material_album": [],
              "delivery_date_flg": 0,
              "alcohol_flg": 0,
              "exceed_percent": 0,
              "low_percent": 0,
              "push_flg": 0,
              "tax": 0,
              "cost_unit": null,
              "cost_unit_rate": null,
              "raw_material_flg": 0,
              "net_rate": 100,
              "yield": 100,
              "standard": {
                "id": 5586,
                "name": "",
                "barcode": "",
                "material_id": 5586,
                "created_id": null,
                "created": "2022/06/30 17:38:21",
                "modified_id": null,
                "modified": "2022/06/30 17:41:11",
                "guid": null
              },
              "standard_name": ""
            },
            "material_category": {
              "id": 138,
              "code": "8FD839A5-E9D3-3648-89E8-54CF7A5E679F",
              "number": "2",
              "name": "蔬菜",
              "parent_id": 137,
              "guid": "8FD839A5-E9D3-3648-89E8-54CF7A5E679F",
              "lev1": null,
              "lev2": null,
              "lev3": null,
              "lev4": null,
              "lev5": null,
              "lev6": null,
              "rank": 2,
              "end_flg": 1,
              "sort": 0,
              "delete_flg": false,
              "ext_code": null
            },
            "category_rank": 1,
            "category_sort": 0,
            "category_number": "1",
            "out_num": 3,
            "distribution_num": 3,
            "examine_num": 0
          }
        ],
        "order_extra": null,
        "qacenter_question": null,
        "granter": {
          "name": "系统管理员",
          "type": 1
        },
        "modifier": {
          "name": "系统管理员",
          "type": 1
        },
        "creater": {
          "name": "系统管理员",
          "type": 1
        },
        "account_user": {
          "name": "系统管理员",
          "type": 1
        },
        "shop": {
          "id": 12,
          "price_level_id": null,
          "shop_code": "017",
          "shop_name": "XX门店",
          "material_template_id": 0,
          "product_template_id": 0,
          "city_1": "B6BCBC1A-D665-F0D7-41FA-2AA3DE0C3CC5",
          "city_2": null,
          "city_3": null,
          "address": "XX号",
          "tel": null,
          "fax": null,
          "email": null,
          "status": 1,
          "comment": "",
          "activation_code": null,
          "pin_code": null,
          "equipment_code": null,
          "reg_code": null,
          "reg_password": null,
          "soft_version": null,
          "device_cnt": 0,
          "reg_flg": 0,
          "erp_account": null,
          "erp_account_code": null,
          "delete_flg": false,
          "created_id": null,
          "created": "2022/08/30 10:57:29",
          "modified_id": null,
          "modified": "2022/08/30 10:57:29",
          "erp_bank": null,
          "lng": null,
          "lat": null,
          "tax_type": null,
          "invoice_type": 0,
          "invoice_title": null,
          "invoice_code": null,
          "company_name": null,
          "balance": 0,
          "sub_account_balance_json": null,
          "collect": null,
          "sub_account_json": null,
          "order_cycles_code": null,
          "shop_pay_setting": 4,
          "shop_bail": null,
          "contract_start": null,
          "contract_end": null,
          "hide_material_price_flg": 0,
          "hide_order_price_flg": 0,
          "national_tax_code": null,
          "province_id": 23,
          "city_id": 304,
          "area_id": 2567,
          "food_template_id": null,
          "psi_enable": 0,
          "psi_apply": 0,
          "bom_modify_flg": 0,
          "psi_start": null,
          "psi_days": null,
          "recommend_agent_id": null,
          "recommend_shop_id": null,
          "print_order_template": null,
          "shop_user": {
            "id": 12,
            "shop_id": 12,
            "login_user_id": "13000000000",
            "type": 1,
            "password": "13000000000",
            "name": "XXX",
            "identification_num": "",
            "tel": "13000000000",
            "mobile": null,
            "email": null,
            "role": 1,
            "sex": null,
            "delete_flg": false,
            "created_id": null,
            "created": "2022/08/30 10:57:29",
            "modified_id": null,
            "modified": "2022/08/30 10:57:29",
            "ext_code": null
          },
          "template_name": "默认模板",
          "actions": {
            "editPsiLifespan": false
          }
        },
        "bill": {
          "id": 362,
          "bill_code": "M20230823000019",
          "bill_type": 101,
          "bill_obj_type": 1,
          "pay_type": 0,
          "credential_type": 4,
          "fee": 48,
          "personal_pay_price": 0,
          "invoice_fee": 0,
          "logistics_fee": 12,
          "sub_account_json": null,
          "sub_account_pay_json": null,
          "shop_id": 12,
          "supplier_id": null,
          "status": 1,
          "pay_flg": 1,
          "bill_check_flg": 0,
          "org_code": "A20230823000010",
          "bank_id": null,
          "actual_date": "2023-08-23 15:38",
          "receive_pc": null,
          "delete_flg": 0,
          "created_id": 1,
          "created": "2023/08/23 15:39:02",
          "modified_id": null,
          "modified": "2023/08/23 15:39:42",
          "district_code": null,
          "org_fee": 36,
          "logistics_sub_account_id": null,
          "core_sub_account_id": null,
          "last_bill_record": null,
          "bill_type_str": "要货对账单",
          "order_type_str": "要货单",
          "io_str": "收",
          "wait_io_type": 1,
          "wait_io_str": "收",
          "status_str": "未支付（未对账）",
          "status_color": "#1485ee",
          "credential_str": "要货出库",
          "creater_name": "system",
          "modifier_name": "system",
          "pay_type_arr": {
            "101": "余额",
            "102": "微信转账",
            "103": "支付宝转账",
            "201": "银行转账",
            "202": "现金",
            "215": "易生退款",
            "217": "汇付退款"
          },
          "refund_pay_arr": {
            "101": "余额",
            "102": "微信转账",
            "103": "支付宝转账",
            "201": "银行转账",
            "202": "现金"
          },
          "up_sum": null,
          "down_sum": null,
          "total_price": 48,
          "cancel_flg": 0,
          "actions": {
            "complete": true,
            "check_bill": true,
            "uncheck_bill": false,
            "pay": false,
            "receive": true,
            "credential_refresh": false
          }
        },
        "for_order": null,
        "apply_num_total": 3,
        "confirm_num_total": 3,
        "fix_num_total": 3,
        "address": {
          "address": "XX号",
          "user_name": "XXX",
          "tel": "19180428941"
        },
        "creater_name": "系统管理员",
        "modifier_name": "系统管理员",
        "granter_name": "系统管理员",
        "admin_user_name": "系统管理员",
        "shop_user_name": "",
        "status_str": "待验收",
        "actions": {
          "add": true,
          "confirm": false,
          "account_edit": false,
          "shop_edit": false,
          "redeliver": false,
          "approve": false,
          "cancel": false,
          "preprint": false,
          "print": true,
          "return_add": true,
          "return_confirm": false,
          "return_edit": false,
          "return_redeliver": false,
          "return_approve": false,
          "return_cancel": false,
          "edit_express_price": false
        },
        "total_coupon_price": 0
      },
    },
  order: {
    "id": 336,
    "order_code": "A20230823000010",
    "ext_code": null,
    "alliance_business_id": null,
    "relation_order_id": null,
    "shop_id": 12,
    "shop_user_id": 12,
    "admin_user": 1,
    "grant_user_id": 1,
    "invoice_url": null,
    "invoice_type": 0,
    "invoice_rate": 0,
    "status": 5,
    "type": 1,
    "return_type": 2,
    "bill_pay_flg": null,
    "bill_status": 1,
    "price_fix": 36,
    "price_cut": 0,
    "order_price": 46,
    "add_flg": 0,
    "cps_json": null,
    "disable_return": 0,
    "disable_cps": false,
    "shop_account_id": null,
    "shop_purchase_code": null,
    "shop_stock_order_code": null,
    "memo": null,
    "delete_flg": false,
    "created_id": 1,
    "created": "2023/08/23 15:39:01",
    "modified_id": 1,
    "modified": "2023/08/23 15:39:42",
    "account_memo": null,
    "expect_date": "2023/08/24 00:00:00",
    "actual_date": "2023/08/23 15:38:51",
    "cancel_flg": 0,
    "cancel_memo": null,
    "print_count": 0,
    "error_flg": 0,
    "expect_return_price": null,
    "remark": null,
    "check_price": null,
    "order_img": "",
    "origin_flg": "001",
    "express_price": 10,
    "edit_express_flg": 0,
    "coupon_detail_id": null,
    "coupon_json": null,
    "details_count": "1",
    "details_num": "3.000",
    "weight_total": "0.0000000000000",
    "bill_price": "60.000",
    "order_details": [
      {
        "id": 711,
        "order_id": 336,
        "category_name": "食材",
        "category_code": "00AE57A6-667A-096D-E4B4-468EA073438B",
        "material_id": 5586,
        "material_code": "010010006",
        "material_name": "草头",
        "material_alias": null,
        "guid": "FBF13A5C-B36A-A900-F7A0-1F046FB271D1",
        "apply_num": 3,
        "confirm_num": 3,
        "add_num": 0,
        "add_num_comfirm": 0,
        "fix_num": 3,
        "org_price": 12,
        "price": 12,
        "total": 36,
        "subtotal": 0,
        "price_flg": 0,
        "confirm_price": 12,
        "auto_flg": 0,
        "production_date": null,
        "expired_date": null,
        "memo": null,
        "delete_flg": false,
        "created_id": null,
        "created": "2023/08/23 15:39:01",
        "modified_id": null,
        "modified": "2023/08/23 15:39:12",
        "unit": "斤",
        "standard_detail_id": 5587,
        "standard_name": "",
        "error_flg": 0,
        "sub_account_price_json": null,
        "order_combine_material_id": null,
        "img": "",
        "campaign_price": null,
        "coupon_price": null,
        "standard_detail": {
          "id": 5587,
          "standard_id": 5586,
          "unit": "斤",
          "rate": 1,
          "weight": null,
          "barcode": "",
          "comment": "",
          "default_flg": 1,
          "status": 0,
          "delete_flg": 0,
          "unit_code": null,
          "net": null,
          "net_unit": "",
          "weight_flg": 0,
          "gross_weight": null,
          "gross_weight_unit": "",
          "count_unit": "",
          "count_unit_rate": 1,
          "gross_weight_config": null,
          "count_unit_flg": 1
        },
        "material": {
          "id": 5586,
          "material_code": "010010006",
          "material_name": "草头",
          "category_code": "8FD839A5-E9D3-3648-89E8-54CF7A5E679F",
          "guid": "77577259-356E-0D6D-F513-CBAE9834099F",
          "cost_method": 1,
          "pinyin": "CT",
          "material_sname": "",
          "bar_code": "",
          "supply_shop": null,
          "default_supplier_id": null,
          "unit_order": "斤",
          "in_price": "0.00",
          "supply_price": "12.00",
          "supply_standard_detail_id": 5587,
          "multiple": null,
          "stock_max": null,
          "stock_min": null,
          "bestbefore": "",
          "nearday": null,
          "origin": "",
          "brand": null,
          "storage_conditions": null,
          "stock_batch_rule_type": 1,
          "comment": null,
          "video": null,
          "min": "0.00",
          "sort": null,
          "hide_flg": 0,
          "public_flg": 1,
          "production_attribute": 0,
          "combine_formula_json": [],
          "split_formula_json": [],
          "delete_flg": false,
          "created_id": 1,
          "created": "2022/06/30 17:38:21",
          "modified_id": null,
          "modified": "2023/03/31 16:58:19",
          "auto_code_number": 0,
          "transport_type": null,
          "storage_type": 30,
          "ext_code": null,
          "ext_img_url": null,
          "delivery_way": null,
          "freight_type": null,
          "material_group": "",
          "material_group_flg": 0,
          "description": "",
          "material_album": [],
          "delivery_date_flg": 0,
          "alcohol_flg": 0,
          "exceed_percent": 0,
          "low_percent": 0,
          "push_flg": 0,
          "tax": 0,
          "cost_unit": null,
          "cost_unit_rate": null,
          "raw_material_flg": 0,
          "net_rate": 100,
          "yield": 100,
          "standard": {
            "id": 5586,
            "name": "",
            "barcode": "",
            "material_id": 5586,
            "created_id": null,
            "created": "2022/06/30 17:38:21",
            "modified_id": null,
            "modified": "2022/06/30 17:41:11",
            "guid": null
          },
          "standard_name": ""
        },
        "material_category": {
          "id": 138,
          "code": "8FD839A5-E9D3-3648-89E8-54CF7A5E679F",
          "number": "2",
          "name": "蔬菜",
          "parent_id": 137,
          "guid": "8FD839A5-E9D3-3648-89E8-54CF7A5E679F",
          "lev1": null,
          "lev2": null,
          "lev3": null,
          "lev4": null,
          "lev5": null,
          "lev6": null,
          "rank": 2,
          "end_flg": 1,
          "sort": 0,
          "delete_flg": false,
          "ext_code": null
        },
        "category_rank": 1,
        "category_sort": 0,
        "category_number": "1",
        "out_num": 3,
        "distribution_num": 3,
        "examine_num": 0
      }
    ],
    "order_extra": null,
    "qacenter_question": null,
    "granter": {
      "name": "系统管理员",
      "type": 1
    },
    "modifier": {
      "name": "系统管理员",
      "type": 1
    },
    "creater": {
      "name": "系统管理员",
      "type": 1
    },
    "account_user": {
      "name": "系统管理员",
      "type": 1
    },
    "shop": {
      "id": 12,
      "price_level_id": null,
      "shop_code": "017",
      "shop_name": "XX门店",
      "material_template_id": 0,
      "product_template_id": 0,
      "city_1": "B6BCBC1A-D665-F0D7-41FA-2AA3DE0C3CC5",
      "city_2": null,
      "city_3": null,
      "address": "XX号",
      "tel": null,
      "fax": null,
      "email": null,
      "status": 1,
      "comment": "",
      "activation_code": null,
      "pin_code": null,
      "equipment_code": null,
      "reg_code": null,
      "reg_password": null,
      "soft_version": null,
      "device_cnt": 0,
      "reg_flg": 0,
      "erp_account": null,
      "erp_account_code": null,
      "delete_flg": false,
      "created_id": null,
      "created": "2022/08/30 10:57:29",
      "modified_id": null,
      "modified": "2022/08/30 10:57:29",
      "erp_bank": null,
      "lng": null,
      "lat": null,
      "tax_type": null,
      "invoice_type": 0,
      "invoice_title": null,
      "invoice_code": null,
      "company_name": null,
      "balance": 0,
      "sub_account_balance_json": null,
      "collect": null,
      "sub_account_json": null,
      "order_cycles_code": null,
      "shop_pay_setting": 4,
      "shop_bail": null,
      "contract_start": null,
      "contract_end": null,
      "hide_material_price_flg": 0,
      "hide_order_price_flg": 0,
      "national_tax_code": null,
      "province_id": 23,
      "city_id": 304,
      "area_id": 2567,
      "food_template_id": null,
      "psi_enable": 0,
      "psi_apply": 0,
      "bom_modify_flg": 0,
      "psi_start": null,
      "psi_days": null,
      "recommend_agent_id": null,
      "recommend_shop_id": null,
      "print_order_template": null,
      "shop_user": {
        "id": 12,
        "shop_id": 12,
        "login_user_id": "13000000000",
        "type": 1,
        "password": "13000000000",
        "name": "XXX",
        "identification_num": "",
        "tel": "13000000000",
        "mobile": null,
        "email": null,
        "role": 1,
        "sex": null,
        "delete_flg": false,
        "created_id": null,
        "created": "2022/08/30 10:57:29",
        "modified_id": null,
        "modified": "2022/08/30 10:57:29",
        "ext_code": null
      },
      "template_name": "默认模板",
      "actions": {
        "editPsiLifespan": false
      }
    },
    "bill": {
      "id": 362,
      "bill_code": "M20230823000019",
      "bill_type": 101,
      "bill_obj_type": 1,
      "pay_type": 0,
      "credential_type": 4,
      "fee": 48,
      "personal_pay_price": 0,
      "invoice_fee": 0,
      "logistics_fee": 12,
      "sub_account_json": null,
      "sub_account_pay_json": null,
      "shop_id": 12,
      "supplier_id": null,
      "status": 1,
      "pay_flg": 1,
      "bill_check_flg": 0,
      "org_code": "A20230823000010",
      "bank_id": null,
      "actual_date": "2023-08-23 15:38",
      "receive_pc": null,
      "delete_flg": 0,
      "created_id": 1,
      "created": "2023/08/23 15:39:02",
      "modified_id": null,
      "modified": "2023/08/23 15:39:42",
      "district_code": null,
      "org_fee": 36,
      "logistics_sub_account_id": null,
      "core_sub_account_id": null,
      "last_bill_record": null,
      "bill_type_str": "要货对账单",
      "order_type_str": "要货单",
      "io_str": "收",
      "wait_io_type": 1,
      "wait_io_str": "收",
      "status_str": "未支付（未对账）",
      "status_color": "#1485ee",
      "credential_str": "要货出库",
      "creater_name": "system",
      "modifier_name": "system",
      "pay_type_arr": {
        "101": "余额",
        "102": "微信转账",
        "103": "支付宝转账",
        "201": "银行转账",
        "202": "现金",
        "215": "易生退款",
        "217": "汇付退款"
      },
      "refund_pay_arr": {
        "101": "余额",
        "102": "微信转账",
        "103": "支付宝转账",
        "201": "银行转账",
        "202": "现金"
      },
      "up_sum": null,
      "down_sum": null,
      "total_price": 48,
      "cancel_flg": 0,
      "actions": {
        "complete": true,
        "check_bill": true,
        "uncheck_bill": false,
        "pay": false,
        "receive": true,
        "credential_refresh": false
      }
    },
    "for_order": null,
    "apply_num_total": 3,
    "confirm_num_total": 3,
    "fix_num_total": 3,
    "address": {
      "address": "XX号",
      "user_name": "XXX",
      "tel": "19180428941"
    },
    "creater_name": "系统管理员",
    "modifier_name": "系统管理员",
    "granter_name": "系统管理员",
    "admin_user_name": "系统管理员",
    "shop_user_name": "",
    "status_str": "待验收",
    "actions": {
      "add": true,
      "confirm": false,
      "account_edit": false,
      "shop_edit": false,
      "redeliver": false,
      "approve": false,
      "cancel": false,
      "preprint": false,
      "print": true,
      "return_add": true,
      "return_confirm": false,
      "return_edit": false,
      "return_redeliver": false,
      "return_approve": false,
      "return_cancel": false,
      "edit_express_price": false
    },
    "total_coupon_price": 0
  },
  adminPurchase: {
    "id": 22,
    "purchase_code": "G20230823000003",
    "ext_code": null,
    "stock_id": 2,
    "quality_is_received": 0,
    "is_received": 0,
    "quality_receive_user_id": 0,
    "receive_user_id": 0,
    "is_quality_checked": 0,
    "supplier_id": 1,
    "hope_delivery_date": "2023/08/24",
    "status": 2,
    "delivery_flg": false,
    "origin_flg": "102",
    "order_code": "A20230823000004",
    "supplier_account_id": null,
    "stock_order_code": "O20230823000006",
    "memo": null,
    "complete_date": null,
    "send_times": 0,
    "stock_out_json": null,
    "delete_flg": false,
    "created_id": 1,
    "created": "2023/08/23 15:04:41",
    "modified_id": 1,
    "modified": "2023/08/23 15:04:41",
    "third_return": null,
    "check_flg": 0,
    "delivery_date": null,
    "total": "6.00",
    "total_num": 2,
    "order_id": 326,
    "purchase_details": [
      {
        "id": 44,
        "purchase_id": 22,
        "material_id": 5999,
        "material_name": "白心火龙果",
        "material_code": "010090002",
        "category_name": "水果",
        "supplier_material_id": null,
        "unit": "斤",
        "material_bar_code": "",
        "rate": 1,
        "quantity": 2,
        "default_quantity": "2.000000",
        "qualify_flg": 0,
        "default_unit": "斤",
        "examine_num": "0",
        "default_examine_num": null,
        "examine_memo": null,
        "tax_flg": 0,
        "tax_rate": 0,
        "negotiate_price_flg": 0,
        "price": 3,
        "memo": null,
        "production_date": null,
        "expired_date": null,
        "standard_name": "",
        "standard_detail_id": 6000,
        "bestbefore": "",
        "weight_rate": null,
        "weight_flg": 1,
        "before_tax_price": 3,
        "after_tax_price": 3,
        "total": "6.00",
        "after_tax_total": "6.00",
        "before_tax_total": "6.00",
        "supply_code": "3",
        "delivery_num": 0,
        "print_delivery_num": 2,
        "prices": 3
      }
    ],
    "stock_order": {
      "id": 213,
      "stock_order_code": "O20230823000006",
      "shop_id": "7",
      "order_extra": null,
      "shop": {
        "id": 7,
        "shop_code": "002",
        "shop_name": "XX门店",
        "address": "XX号",
        "tel": null,
        "province_id": 23,
        "city_id": 288,
        "area_id": 2452,
        "shop_user": {
          "id": 7,
          "name": "XXX",
          "tel": "13000000000",
          "mobile": null
        },
        "template_name": "默认模板",
        "actions": {
          "editPsiLifespan": false
        }
      },
      "out_type_str": "",
      "in_type_str": "",
      "status_str": null,
      "sorting_status_str": "",
      "status_color": "#3F51B5",
      "supplier_name": "",
      "creater_name": "system",
      "modifier_name": "system",
      "executer_name": "system",
      "operater_name": "system",
      "applier_name": "system",
      "granter_name": "system",
      "actions": {
        "out_approve": false,
        "out_edit": false,
        "out_complete": false,
        "out_cancel": false,
        "sheet_print": false,
        "in_approve": false,
        "in_edit": false,
        "in_complete": false,
        "shelve_on": false,
        "batch_shelve_on": false,
        "in_cancel": false,
        "common_sorting_out": false
      }
    },
    "purchase_detail": {
      "id": 44,
      "purchase_id": 22,
      "material_id": 5999,
      "supplier_material_id": null,
      "quantity": 2,
      "examine_num": "0",
      "examine_memo": null,
      "qualify_flg": 0,
      "prices": 3,
      "negotiate_price_flg": 0,
      "memo": null,
      "quality_standard_img": null,
      "quality_standard": null,
      "parent_id": null,
      "production_date": null,
      "expired_date": null,
      "standard_detail_id": 6000,
      "standard_name": "",
      "tax_flg": 0,
      "tax_rate": 0,
      "img": null
    },
    "creater": {
      "name": "系统管理员",
      "type": 1
    },
    "supplier": {
      "id": 1,
      "supplier_code": "A",
      "supplier_name": "A001",
      "city_1": null,
      "address": null,
      "manager_name": "A ",
      "manager_tel": "00000000",
      "bank": null,
      "account_name": null,
      "account_num": null,
      "comment": null,
      "type": 1,
      "material_multi_unit": 0,
      "order_to_purchase": 1,
      "purchase_after_set_price": 0,
      "account_id": null,
      "login_user_id": null,
      "password": null,
      "access_token": null,
      "token_expired": null,
      "tax_num": null,
      "email": null,
      "delete_flg": 0,
      "created_id": 1,
      "created": "2023/03/30 13:57:54",
      "modified_id": null,
      "modified": "2023/03/30 13:57:54",
      "stop_flg": 0,
      "business_license": null,
      "attachment": null,
      "national_tax_code": null,
      "tax_type": null,
      "province_id": null,
      "city_id": null,
      "area_id": null,
      "delivery_flg": 1,
      "delivery_modify_flg": 1,
      "bill_for_shop_examine": 1,
      "edit_material_flg": 0,
      "exceed_percent": 0,
      "low_percent": 0,
      "third_param": null,
      "supply_type": "普通供应商",
      "stop_flg_str": "启用",
      "business_license_url": "",
      "attachment_url": []
    },
    "stock": {
      "id": 2,
      "name": "A001",
      "manager": null,
      "address": null,
      "tel": null,
      "province_id": null,
      "city_id": null,
      "area_id": null,
      "sorting_num_exceed": "0",
      "sorting_num_less": "0",
      "position_material_mix": 1,
      "position_batch_mix": 1,
      "code": null
    },
    "details_count": 1,
    "total_delivery_num": 0,
    "total_quantity_num": 2,
    "wait_examine_total_weight": 0,
    "examined_total_weight": 0,
    "examined_material_count": 0,
    "wait_examine_material_count": 1,
    "quantity_price_total": 6,
    "default_quantity_total": 2,
    "examine_price_total": 0,
    "NoPartExamineFlg": 0,
    "delivery_info": {
      "object": "XX门店",
      "province_id": 23,
      "city_id": 288,
      "area_id": 2452,
      "address": "XX号",
      "name": "XXX",
      "tel": "13000000000"
    },
    "status_str": "未发货",
    "delivery_flg_str": "未发货",
    "only_status_str": "待验收",
    "status_color": "#FF0000",
    "actions": {
      "notice": true,
      "edit": false,
      "delivery": true,
      "quality_check": false,
      "examine": false,
      "cancel": false,
      "confirm": false,
      "over": false,
      "check": true,
      "copy": false
    },
    "creater_name": "系统管理员",
    "check_status_str": "未查收"
  }
}